/**
 * @generated SignedSource<<26c17255d6b5dd66635b5f60e193486d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CampaignDetailScreenQuery$variables = {
  campaignId: string;
  influencerId: string;
};
export type CampaignDetailScreenQuery$data = {
  readonly campaign: {
    readonly __typename: "Campaign";
    readonly " $fragmentSpreads": FragmentRefs<"CampaignDetailCampaign">;
  } | {
    readonly __typename: "NotFoundError";
    readonly message: string;
  } | {
    // This will never be '%other', but we need some
    // value in case none of the concrete values match.
    readonly __typename: "%other";
  };
  readonly candidate: {
    readonly " $fragmentSpreads": FragmentRefs<"CampaignDetailUnitPrice">;
  } | null;
  readonly influencer: {
    readonly " $fragmentSpreads": FragmentRefs<"CampaignActionCandidates">;
  };
  readonly " $fragmentSpreads": FragmentRefs<"CampaignDetailRelatedList">;
};
export type CampaignDetailScreenQuery = {
  response: CampaignDetailScreenQuery$data;
  variables: CampaignDetailScreenQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "campaignId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "influencerId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "campaignId"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v3 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "message",
      "storageKey": null
    }
  ],
  "type": "NotFoundError",
  "abstractKey": null
},
v4 = {
  "kind": "Variable",
  "name": "campaignId",
  "variableName": "campaignId"
},
v5 = [
  (v4/*: any*/),
  {
    "kind": "Variable",
    "name": "influencerId",
    "variableName": "influencerId"
  }
],
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "prType",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "postalCode",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "prefectureName",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "cityName",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "townName",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "recruitmentEndOn",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "gifting",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isFavoriteCheck",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "concreteType": "Banner",
  "kind": "LinkedField",
  "name": "banners",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "file",
      "storageKey": null
    },
    (v6/*: any*/)
  ],
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "concreteType": "MCategory",
  "kind": "LinkedField",
  "name": "mCategory",
  "plural": false,
  "selections": [
    (v12/*: any*/),
    (v6/*: any*/)
  ],
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "parentMediaType",
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "CampaignDetailScreenQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "campaign",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "CampaignDetailCampaign"
              }
            ],
            "type": "Campaign",
            "abstractKey": null
          },
          (v3/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "Influencer",
        "kind": "LinkedField",
        "name": "influencer",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "CampaignActionCandidates"
          }
        ],
        "storageKey": null
      },
      {
        "args": [
          (v4/*: any*/)
        ],
        "kind": "FragmentSpread",
        "name": "CampaignDetailRelatedList"
      },
      {
        "alias": null,
        "args": (v5/*: any*/),
        "concreteType": "Candidate",
        "kind": "LinkedField",
        "name": "candidate",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "CampaignDetailUnitPrice"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "CampaignDetailScreenQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "campaign",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              (v6/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "mediaType",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "giftingDetail",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "askingPrice",
                "storageKey": null
              },
              (v7/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "SocialNetwork",
                "kind": "LinkedField",
                "name": "socialNetwork",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "castPlanName",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "deliveryOn",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "castContent",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "productUrl",
                    "storageKey": null
                  },
                  (v8/*: any*/),
                  (v9/*: any*/),
                  (v10/*: any*/),
                  (v11/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "buildingName",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "castIntro",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "RelatedCast",
                    "kind": "LinkedField",
                    "name": "relatedCasts",
                    "plural": true,
                    "selections": [
                      (v6/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "relatedInfoUrl",
                        "storageKey": null
                      },
                      (v12/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v6/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "castingCondition",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "recruitmentStartOn",
                    "storageKey": null
                  },
                  (v13/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "postStartOn",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "postEndOn",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "castStartAt",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "castEndAt",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "ytHashTag",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "hashTag",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "productIntro",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "mentionTag",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "mentionTagContent",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "secondhand",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "secondhandContent",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "productSupply",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              (v14/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "productDetail",
                "storageKey": null
              },
              (v15/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "advertiserName",
                "storageKey": null
              },
              (v16/*: any*/),
              (v17/*: any*/),
              (v18/*: any*/),
              (v19/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "purpose",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "avoidedSentence",
                "storageKey": null
              },
              (v20/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasDelivery",
                "storageKey": null
              }
            ],
            "type": "Campaign",
            "abstractKey": null
          },
          (v3/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "Influencer",
        "kind": "LinkedField",
        "name": "influencer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Candidate",
            "kind": "LinkedField",
            "name": "candidates",
            "plural": true,
            "selections": [
              (v6/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "campaignId",
                "storageKey": null
              },
              (v20/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Post",
                "kind": "LinkedField",
                "name": "post",
                "plural": false,
                "selections": [
                  (v6/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "firstName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "lastName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "email",
            "storageKey": null
          },
          (v8/*: any*/),
          (v9/*: any*/),
          (v10/*: any*/),
          (v11/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "linkingInstagram",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "linkingTwitter",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "phoneNumber",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "InfluencerInfo",
            "kind": "LinkedField",
            "name": "profile",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "commonName",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "gender",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "birthday",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "tiktokUrl",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "ytChannel",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "invoiceStatus",
                "storageKey": null
              },
              (v6/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "InfluencerCategory",
            "kind": "LinkedField",
            "name": "influencerCategories",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "categoryName",
                "storageKey": null
              },
              (v6/*: any*/)
            ],
            "storageKey": null
          },
          (v6/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Campaign",
        "kind": "LinkedField",
        "name": "relatedCampaigns",
        "plural": true,
        "selections": [
          (v6/*: any*/),
          (v14/*: any*/),
          (v19/*: any*/),
          (v15/*: any*/),
          (v7/*: any*/),
          (v16/*: any*/),
          (v17/*: any*/),
          (v18/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "SocialNetwork",
            "kind": "LinkedField",
            "name": "socialNetwork",
            "plural": false,
            "selections": [
              (v13/*: any*/),
              (v6/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v5/*: any*/),
        "concreteType": "Candidate",
        "kind": "LinkedField",
        "name": "candidate",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "price",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "customPrice",
            "storageKey": null
          },
          (v20/*: any*/),
          (v6/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "c586edf8918769d83fae6fa569b4d602",
    "id": null,
    "metadata": {},
    "name": "CampaignDetailScreenQuery",
    "operationKind": "query",
    "text": "query CampaignDetailScreenQuery(\n  $campaignId: ID!\n  $influencerId: ID!\n) {\n  campaign(id: $campaignId) {\n    __typename\n    ... on Campaign {\n      ...CampaignDetailCampaign\n      id\n    }\n    ... on NotFoundError {\n      message\n    }\n  }\n  influencer {\n    ...CampaignActionCandidates\n    id\n  }\n  ...CampaignDetailRelatedList_106Vhw\n  candidate(influencerId: $influencerId, campaignId: $campaignId) {\n    ...CampaignDetailUnitPrice\n    id\n  }\n}\n\nfragment CampaignActionCampaign on Campaign {\n  id\n  parentMediaType\n  status\n  isFavoriteCheck\n  ...requirementForApplyCampaign\n}\n\nfragment CampaignActionCandidates on Influencer {\n  candidates {\n    id\n    campaignId\n    status\n    post {\n      id\n    }\n  }\n  ...requirementForApplyInfluencer\n}\n\nfragment CampaignCast on Campaign {\n  socialNetwork {\n    castPlanName\n    deliveryOn\n    castContent\n    productUrl\n    postalCode\n    prefectureName\n    cityName\n    townName\n    buildingName\n    castIntro\n    relatedCasts {\n      id\n      relatedInfoUrl\n      name\n    }\n    id\n  }\n}\n\nfragment CampaignContents on Campaign {\n  mediaType\n  purpose\n  avoidedSentence\n  mCategory {\n    name\n    id\n  }\n  socialNetwork {\n    ytHashTag\n    hashTag\n    productIntro\n    mentionTag\n    mentionTagContent\n    productUrl\n    secondhand\n    secondhandContent\n    productSupply\n    id\n  }\n}\n\nfragment CampaignDetailCampaign on Campaign {\n  id\n  mediaType\n  ...CampaignReward\n  ...CampaignCast\n  ...CampaignQualification\n  ...CampaignProduct\n  ...CampaignMain\n  ...CampaignContents\n  ...CampaignActionCampaign\n}\n\nfragment CampaignDetailRelatedList_106Vhw on Query {\n  relatedCampaigns(id: $campaignId) {\n    id\n    ...CampaignRelated\n  }\n}\n\nfragment CampaignDetailUnitPrice on Candidate {\n  ...CampaignMainCampaignDetailUnitPrice\n}\n\nfragment CampaignMain on Campaign {\n  id\n  title\n  mediaType\n  gifting\n  prType\n  advertiserName\n  isFavoriteCheck\n  banners {\n    file\n    id\n  }\n  mCategory {\n    name\n    id\n  }\n  socialNetwork {\n    recruitmentStartOn\n    recruitmentEndOn\n    postStartOn\n    postEndOn\n    castStartAt\n    castEndAt\n    id\n  }\n  ...SNSBadge_mediaType\n}\n\nfragment CampaignMainCampaignDetailUnitPrice on Candidate {\n  price\n  customPrice\n  status\n}\n\nfragment CampaignProduct on Campaign {\n  title\n  mediaType\n  productDetail\n}\n\nfragment CampaignQualification on Campaign {\n  socialNetwork {\n    castingCondition\n    id\n  }\n}\n\nfragment CampaignRelated on Campaign {\n  id\n  title\n  parentMediaType\n  gifting\n  prType\n  isFavoriteCheck\n  banners {\n    file\n    id\n  }\n  mCategory {\n    name\n    id\n  }\n  socialNetwork {\n    recruitmentEndOn\n    id\n  }\n}\n\nfragment CampaignReward on Campaign {\n  giftingDetail\n  askingPrice\n  prType\n}\n\nfragment SNSBadge_mediaType on Campaign {\n  parentMediaType\n  mediaType\n}\n\nfragment requirementForApplyCampaign on Campaign {\n  parentMediaType\n  hasDelivery\n}\n\nfragment requirementForApplyInfluencer on Influencer {\n  firstName\n  lastName\n  email\n  postalCode\n  prefectureName\n  cityName\n  townName\n  linkingInstagram\n  linkingTwitter\n  phoneNumber\n  profile {\n    commonName\n    gender\n    birthday\n    tiktokUrl\n    ytChannel\n    invoiceStatus\n    id\n  }\n  influencerCategories {\n    categoryName\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "f270eeb7dfee796340e328f7bb11389c";

export default node;
